// extracted by mini-css-extract-plugin
export var deliveryRow = "_rb-a";
export var fixedHeight = "_rb-4";
export var freightLogo = "_rb-9";
export var fullWidth = "_rb-3";
export var priceColumn = "_rb-5";
export var radioSelected = "_rb-7";
export var radioUnselected = "_rb-6";
export var selectedOption = "_rb-2";
export var selectedOptionContainer = "_rb-1";
export var selection = "_rb-0";
export var tallSkeletonText = "_rb-8";